import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { StyledTableCell, StyledTableRow } from "../../styles/tableStyles";
import { Stack } from "@mui/material";

interface TableSkeletonProps {
  numRows: number;
  numColumns: number;
}
function TableSkeleton({ numRows, numColumns }: TableSkeletonProps) {
  return (
    <>
      {new Array(numRows).fill("", 0, numRows).map((p, i) => (
        <StyledTableRow key={i}>
          {new Array(numColumns).fill("", 0, numColumns).map((p, j) => (
            <StyledTableCell key={j}>
              <Skeleton
                animation="wave"
                variant="rounded"
                height={16}
                sx={{ borderRadius: 1 }}
              />
            </StyledTableCell>
          ))}

          <StyledTableCell>
            <Stack direction="row" spacing={1} alignItems="center">
              {[0, 1, 2].map((k) => (
                <Skeleton
                  key={k}
                  animation="wave"
                  variant="circular"
                  width={24}
                  height={24}
                />
              ))}
            </Stack>
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </>
  );
}

export default TableSkeleton;
